// Fonte: UManutContas.dfm — Painel P8, Ds_Funcionario → tabela Contas_De_Prest_Servico
import React, { useState } from 'react';
import { Form, Row, Col, Card, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import aplicarMascara from './mascaras';

// Fonte: UManutContas.dfm, RxDBComboBox6 — Items.Strings / Values.Strings (linhas 2698-2722)
var TIPO_PRESTADOR = [
  { value: 'V', label: 'Vendedor Interno' },
  { value: 'E', label: 'Vendedor Externo' },
  { value: 'N', label: 'Não Vendedor' },
  { value: 'F', label: 'Funcionário' },
  { value: 'O', label: 'Operador' },
  { value: 'A', label: 'Agente' },
  { value: '1', label: 'Cobrador Interno' },
  { value: '2', label: 'Cobrador Externo' },
  { value: '3', label: 'Tribunal Arbitral' },
  { value: '4', label: 'Notificação Extra-Judicial' },
  { value: '5', label: 'Jurídico' },
];

var TIPO_PESSOA = [
  { value: '0', label: 'Física' },
  { value: '1', label: 'Jurídica' },
];

var CAPTACAO = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

var FormTipo8 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;

  var cidades = (lookups && lookups.cidades) ? lookups.cidades : [];
  var tabelasComissao = (lookups && lookups.tabelasComissao) ? lookups.tabelasComissao : [];

  // Fonte: UManutContas.dfm L2786/L2907 — DDD e UF readonly de Ds_Tab_Cidades
  var cidadeSelecionada = cidades.find(function(c) {
    return c.value === (formik.values.tipo8 ? formik.values.tipo8.codigo_cidade : null);
  });
  var ddd = cidadeSelecionada && cidadeSelecionada.ddd !== undefined && cidadeSelecionada.ddd !== null ? String(cidadeSelecionada.ddd) : '';
  var uf = cidadeSelecionada && cidadeSelecionada.uf ? cidadeSelecionada.uf : '';

  var val = function(campo) {
    var v = formik.values['tipo8'] ? formik.values['tipo8'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var handleChange = function(e) {
    formik.setFieldValue('tipo8.' + e.target.name, e.target.value);
  };

  var handleMasked = function(name, tipo) {
    return function(e) {
      formik.setFieldValue('tipo8.' + name, aplicarMascara(e.target.value, tipo));
    };
  };

  var valMask = function(campo, tipo) {
    return aplicarMascara(val(campo), tipo);
  };

  var [aberto, setAberto] = useState(true);

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Funcionário / Prestador de Serviço</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Nome Prestador *</Form.Label>
            <Form.Control
              type="text" size="sm" name="nome_prestador"
              value={val('nome_prestador')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">CPF/CNPJ *</Form.Label>
            <Form.Control
              type="text" size="sm" name="cgc"
              value={valMask('cgc', 'cpf')} onChange={handleMasked('cgc', 'cpf')}
              maxLength={18} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">RG</Form.Label>
            <Form.Control
              type="text" size="sm" name="rg"
              value={val('rg')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Tipo Pessoa *</Form.Label>
            <Select
              options={TIPO_PESSOA}
              value={TIPO_PESSOA.find(function(t) { return t.value === val('tipo_pessoa'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo8.tipo_pessoa', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-3">
            <Form.Label className="small mb-1">Endereço</Form.Label>
            <Form.Control
              type="text" size="sm" name="endereco"
              value={val('endereco')} onChange={handleChange}
              maxLength={40} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Bairro</Form.Label>
            <Form.Control
              type="text" size="sm" name="bairro"
              value={val('bairro')} onChange={handleChange}
              maxLength={20} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">CEP</Form.Label>
            <Form.Control
              type="text" size="sm" name="cep"
              value={valMask('cep', 'cep')} onChange={handleMasked('cep', 'cep')}
              maxLength={9} disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Cidade *</Form.Label>
            <Select
              placeholder="Selecione a cidade..."
              options={cidades}
              isLoading={lookupsLoading}
              value={cidades.find(function(c) { return c.value === val('codigo_cidade'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo8.codigo_cidade', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              noOptionsMessage={function() { return 'Nenhuma cidade'; }}
            />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">UF</Form.Label>
            <Form.Control type="text" size="sm" value={uf} readOnly disabled />
          </Col>
          <Col md={1} className="mb-3">
            <Form.Label className="small mb-1">DDD</Form.Label>
            <Form.Control type="text" size="sm" value={ddd} readOnly disabled />
          </Col>
        </Row>
        <Row>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Fone</Form.Label>
            <Form.Control
              type="text" size="sm" name="fone"
              value={valMask('fone', 'fone')} onChange={handleMasked('fone', 'fone')}
              maxLength={14} disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">E-mail</Form.Label>
            <Form.Control
              type="email" size="sm" name="email"
              value={val('email')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Tipo Prestador *</Form.Label>
            <Select
              options={TIPO_PRESTADOR}
              value={TIPO_PRESTADOR.find(function(t) { return t.value === val('tipo'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo8.tipo', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Dt. Início</Form.Label>
            <Form.Control
              type="date" size="sm" name="data_inicio"
              value={val('data_inicio')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Tab. Comissão</Form.Label>
            <Select
              placeholder="Selecione..."
              options={tabelasComissao}
              isLoading={lookupsLoading}
              value={tabelasComissao.find(function(t) { return t.value === val('codigo_tab_comissao'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo8.codigo_tab_comissao', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              isClearable
              noOptionsMessage={function() { return 'Nenhuma tabela'; }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Captação</Form.Label>
            <Select
              options={CAPTACAO}
              isClearable
              value={CAPTACAO.find(function(c) { return c.value === val('captacao'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo8.captacao', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">CRECI</Form.Label>
            <Form.Control
              type="text" size="sm" name="creci"
              value={val('creci')} onChange={handleChange}
              disabled={!modoEdicao}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormTipo8;
